import { render, staticRenderFns } from "./auto-messages.vue?vue&type=template&id=6cf6f3b2&"
import script from "./auto-messages.vue?vue&type=script&lang=js&"
export * from "./auto-messages.vue?vue&type=script&lang=js&"
import style0 from "./auto-messages.vue?vue&type=style&index=0&id=6cf6f3b2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports